import {
  CHARGING_HISTORY_API,
  CUSTOMER_EVENTS_API,
} from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import {
  fetchCustomerEventsSuccess,
  fetchCustomerEventsFailure,
  fetchStationChargingHistorySuccess,
  fetchStationChargingHistoryFailure,
  fetchCustomerChargingHistorySuccess,
  fetchCustomerChargingHistoryFailure,
} from "./reducer";

export const fetchCustomerEvents = (id) => async (dispatch) => {
  try {
    await determineBaseUrlAndPerformApiCall(
      `${CUSTOMER_EVENTS_API}?customerId=${id?.original?.CustomerId || id}`,
      "GET"
    )
      .then((response) => {
        if (!response.error) {
          dispatch(fetchCustomerEventsSuccess(response));
        }
        if (response.error) {
          dispatch(fetchCustomerEventsFailure(response.error.message));
        }
      })
      .catch((error) => {});
  } catch (error) {
    dispatch(fetchCustomerEventsFailure(error.message));
  }
};

export const fetchCustomerChargingHistory =
  (customerId, lastCompletedAt, setLoading, setHasNextPage) =>
  async (dispatch) => {
    try {
      if (setLoading) setLoading(true);

      const cursor = lastCompletedAt || "";
      const response = await determineBaseUrlAndPerformApiCall(
        `${CHARGING_HISTORY_API}?customerId=${customerId}&limit=10&lastCompletedAt=${cursor}`,
        "GET"
      );

      if (!response.error) {
        dispatch(fetchCustomerChargingHistorySuccess(response));
        if (setHasNextPage) setHasNextPage((response.data?.length ?? 0) === 10);
      } else {
        dispatch(fetchCustomerChargingHistoryFailure(response.error.message));
        if (setHasNextPage) setHasNextPage(false);
      }
    } catch (error) {
      dispatch(fetchCustomerChargingHistoryFailure("Something went wrong"));
      if (setHasNextPage) setHasNextPage(false);
    } finally {
      if (setLoading) setLoading(false);
    }
  };

export const fetchStationChargingHistory =
  (stationId, lastCompletedAt, setLoading, setHasNextPage) =>
  async (dispatch) => {
    try {
      if (setLoading) setLoading(true);

      const cursor = lastCompletedAt || "";
      const response = await determineBaseUrlAndPerformApiCall(
        `${CHARGING_HISTORY_API}?stationId=${stationId}&limit=10&lastCompletedAt=${cursor}`,
        "GET"
      );

      if (!response.error) {
        dispatch(fetchStationChargingHistorySuccess(response));
        if (setHasNextPage) setHasNextPage((response.data?.length ?? 0) === 10);
      } else {
        dispatch(fetchStationChargingHistoryFailure(response.error.message));
        if (setHasNextPage) setHasNextPage(false);
      }
    } catch (error) {
      dispatch(fetchStationChargingHistoryFailure("Something went wrong"));
      if (setHasNextPage) setHasNextPage(false);
    } finally {
      if (setLoading) setLoading(false);
    }
  };
